import {
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
} from "@chakra-ui/react";
import { IssueDetail } from "models/issue";
import { useUserDetailQuery } from "features/User/hooks";
import { CheckSlackMessageAuthorization } from "features/User/Components/Slack";
import { ResolutionInfo } from "models/resolutions";
import { GrayTableButton } from "components/Button/TableButton";
import { SendMessageModalForm } from "features/SendMessage/SendMessageForm";
import generateSlackAuthorizationMessage from "features/SendMessage/utils/generateSlackAuthorizationMessage";
import { ActionV2 } from "features/Resources/Shared/models";

export function unauthorizedMessageSenderIssueType(_: IssueDetail) {
  return "Unauthorized Message Sender";
}

export function IssueModalInputFields({ issue }: { issue: IssueDetail }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { data: user } = useUserDetailQuery(issue?.context?.userId, {
    enabled: !!issue?.context?.userId,
    staleTime: 0,
  });

  const draftMessage = generateSlackAuthorizationMessage(user);

  return (
    <>
      <Flex direction="column" gap="4">
        <CheckSlackMessageAuthorization userId={issue?.context?.userId} />
        <GrayTableButton
          onClick={onOpen}
          width="fit-content"
          isDisabled={!user?.id}
        >
          Remind
          {" "}
          {user?.firstName || "User"}
          {" "}
          to Authorize
        </GrayTableButton>
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose} size="2xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Send Reminder</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {user && (
              <SendMessageModalForm
                targetId={user.id}
                targetType="User"
                draftMessage={draftMessage}
                onClose={onClose}
              />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export function unauthorizedMessageSenderResolution(issue: IssueDetail): ResolutionInfo {
  const { user } = issue || {};
  return ({
    issueType: "unauthorized_message_sender",
    tagText: unauthorizedMessageSenderIssueType(issue),
    title: `Messages with unauthorized sender ${user?.fullName}`,
    actionTitle: (_: ActionV2) => `This message has an unauthorized sender ${user?.fullName}`,
    additionalContext: `${user?.firstName || "This user"} needs to authorize Camino in Slack to send messages on their behalf. They must go to their profile settings and grant authorization to Camino.`,
    inputComponent: IssueModalInputFields,
  });
}
